import { UseMutationOptions, useMutation, useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";

/** New Ownership: properties in the community without an active ownership. */
export const useGetAvailableProperties = ({ communityId }: { communityId: string }): UseQueryResult<any> =>
  useQuery({
    queryKey: ["available-properties", communityId],
    queryFn: () => axiosAuth.get(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/available-properties`),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId && communityId != "all",
  });

/** POST /v2/community/{c}/property-ownerships — create a title with its owners. */
export const useCreateOwnershipMutation = (
  queryParams?: UseMutationOptions<any, Error, { communityId: string; data: any }, unknown>
) =>
  useMutation({
    mutationFn: async ({ communityId, data }: { communityId: string; data: any }) =>
      await axiosAuth.post(`${PROPERTY_OWNERSHIP_V2_API(communityId)}`, data),
    ...queryParams,
  });
